import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import {UserService} from "../../services/user.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    moduleId: module.id,
    selector: 'reset-password',
    templateUrl: 'reset-password.html'
})

export class ResetPasswordComponent{
    password: string;
    confirm: string;
    accessToken: string;
    loading: boolean = false;
    resetPassword(): void {
        var me = this;
        let router = this.router;
        if (!this.password || this.password !== this.confirm) {
            this.toastr.error("Passwords must match");
            this.password = '';
            this.confirm = '';
            return;
        }
        me.loading = true;
        this.userService.passwordReset(this.password, this.accessToken)
            .then(function(result){
                me.loading = false;
                if (!result) {
                    return me.toastr.error("Token invalid or expired. Please request a new password reset.")
                }
                me.toastr.info("Password reset successful");
                router.navigate(['/login'])
            })
    }
    constructor(
        private userService: UserService,
        private router: Router,
        private toastr: ToastsManager,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            //grab the temporary access token and use that to change
            //this user's password
            this.accessToken = params['accessToken'];
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/components/reset-password/reset-password.component.ts